import { useContext } from 'react';
import { DebtorAccountContext } from '../../contexts/DebtorAccountContext';
import { DebtorAccountContextType } from '../../contexts/DebtorAccountContext.types';

export const useDebtorAccount = (): DebtorAccountContextType => {
  const context = useContext(DebtorAccountContext);
  if (!context) {
    throw new Error(
      'useDebtorAccount must be used within a DebtorAccountProvider',
    );
  }
  return context;
};